"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var ride_hailing_const_1 = require("./ride-hailing.const");
/**
 * RideHailingService
 * @class
 */
var RideHailingService = /** @class */ (function () {
    function RideHailingService() {
    }
    /**
     * Updates payout status details for a given uuid
     * @param payoutUuid {string}
     * @returns `any`
     */
    RideHailingService.prototype.putPayoutStatus = function (payoutUuid, data) {
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.putPayoutStatus.replace('{{payoutUuid}}', payoutUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Retrieves payout status details for a given payoutUuid
     * @param payoutUuid {string}
     * @returns `any`
     */
    RideHailingService.prototype.getPayoutDetails = function (payoutUuid) {
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.getPayoutDetails.replace('{{payoutUuid}}', payoutUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Retrieves incentive details for a given incentiveUuid
     * @param incentiveUuid {string}
     * @returns `any`
     */
    RideHailingService.prototype.getIncentiveDetails = function (incentiveUuid) {
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.incentiveDetails.replace('{{incentiveUuid}}', incentiveUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Update incentive details for a given incentiveUuid
     * @param incentiveUuid {string}
     * @returns `any`
     */
    RideHailingService.prototype.putIncentiveDetails = function (data) {
        var incentiveUuid = data.uuid;
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.incentiveDetails.replace('{{incentiveUuid}}', incentiveUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Create incentive details
     * @returns `any`
     */
    RideHailingService.prototype.postIncentiveDetails = function (data) {
        return axios_client_service_1.axiosClientInstance.post(ride_hailing_const_1.RIDE_HAILING_ENDPOINT.incentiveList, data);
    };
    /**
     * Retrieves incentive List
     * @returns `any`
     */
    RideHailingService.prototype.getIncentiveList = function () {
        return axios_client_service_1.axiosClientInstance.get(ride_hailing_const_1.RIDE_HAILING_ENDPOINT.incentiveList);
    };
    return RideHailingService;
}());
/**
 * RideHailingService Class Instance
 * @namespace
 */
exports.ridehailing = new RideHailingService();
